<template>
    <v-col
      sm="4"
      cols="12"
    >
      <div class="footer__contact-title">{{ $t('footer.contact.title')}}</div>
      <p>
        {{ contact.address }}<br>
        {{ contact.city }}<br>
        <a :href="`mailto:${contact.mail}`">{{ contact.mail }}</a><br>
        {{ contact.phone }}
      </p>
      <v-btn
        outlined
        color="#fff"
        class="rounded-0"
        :href="`https://www.lausanne-tourisme.ch/${locale}/tourism-offices/`"
      >
        {{ $t('footer.contact.offices') }}
      </v-btn>
    </v-col>
</template>

<script>
  export default {
    name: 'TheFooterContact',

    data() {
      return {
        contact: {
          address: 'Avenue de Rhodanie 2 – CP 975',
          city: '1001 Lausanne – Suisse',
          mail: 'info@lausanne-tourisme.ch',
          phone: '41 21 613 73 73',
        },
      }
    },

    computed: {
      locale() {
        return this.$store.state.locale
      },
    },
  }
</script>

<style lang="sass" scoped>
  a
    text-decoration: none
    color: #fff !important

  .footer__contact-title
    font-size: 16px
    font-weight: bold
    padding-bottom: 10px
</style>
